/* infinite-qty.js — Turbo + Infinite Options (oeil_gauche / oeil_droit) — v5
   - Message SOUS les 2 sélecteurs
   - Quantité auto: 1 si OG=OD, 2 sinon
   - Affiche un "Total estimé" sur la PDP (prix x quantité)
   - Panier/Drawer : impossible de descendre < 2 quand OG≠OD (désactivation + anti-bypass réseau)
*/
(function () {
  /* ====== helpers champs ====== */
  function q(sel, root){ return (root||document).querySelector(sel); }
  function qa(sel, root){ return Array.from((root||document).querySelectorAll(sel)); }
  const normalize = v => (v || '').toString().trim();
  function getLeftField(scope) {
    const r = scope || document;
    return q('[name="properties[oeil_gauche]"]', r)
        || q('[name="oeil_gauche"]', r)
        || q('.product-option-custom.mood-eye-left select, .product-option-custom.mood-eye-left input', r)
        || q('[name="properties[oeil_gauche]"], [name="oeil_gauche"], .product-option-custom.mood-eye-left select, .product-option-custom.mood-eye-left input');
  }
  function getRightField(scope) {
    const r = scope || document;
    return q('[name="properties[oeil_droit]"]', r)
        || q('[name="oeil_droit"]', r)
        || q('.product-option-custom.mood-eye-right select, .product-option-custom.mood-eye-right input', r)
        || q('[name="properties[oeil_droit]"], [name="oeil_droit"], .product-option-custom.mood-eye-right select, .product-option-custom.mood-eye-right input');
  }
  function getQtyInput(form) {
    return q('input[name="quantity"], input[id*="quantity"]', form);
  }
  function computeQty(l, r) {
    const L = normalize(l), R = normalize(r);
    if (!L || !R) return 1;
    return L === R ? 1 : 2;
  }
  function commonAncestor(a, b) {
    if (!a || !b) return null;
    const set = new Set(); let n = a;
    while (n) { set.add(n); n = n.parentElement; }
    n = b; while (n) { if (set.has(n)) return n; n = n.parentElement; }
    return null;
  }

  /* ====== PDP: message + total ====== */
  function ensureHintAfterWrapper(form) {
    const leftWrap  = q('.product-option-custom.mood-eye-left', form)  || getLeftField(form)?.closest('.product-option-custom') || getLeftField(form)?.closest('div');
    const rightWrap = q('.product-option-custom.mood-eye-right', form) || getRightField(form)?.closest('.product-option-custom') || getRightField(form)?.closest('div');
    const wrapper = commonAncestor(leftWrap, rightWrap) || form;

    let hint = q('#ogod-hint', form.parentElement || form);
    if (!hint) {
      hint = document.createElement('div');
      hint.id = 'ogod-hint';
      hint.className = 'ogod-hint';
      hint.innerHTML =
        '<div class="ogod-lines">' +
          '✅ Corrections identiques : <strong>1 boîte</strong> sera ajoutée<br>' +
          'ℹ️ Corrections différentes : <strong>2 boîtes</strong> seront ajoutées (une par œil).' +
        '</div>' +
        '<div class="ogod-state" aria-live="polite"></div>' +
        '<div class="ogod-total" aria-live="polite" style="margin-top:4px;"></div>';
      if (wrapper.nextSibling) { wrapper.parentNode.insertBefore(hint, wrapper.nextSibling); }
      else { wrapper.parentNode.appendChild(hint); }
    }
    return hint;
  }

  function readUnitPriceCents(form) {
    // 1) data-attributes (les thèmes sérieux exposent un prix en cents)
    const d = q('[data-product-price],[data-price],[data-product-price-cents]', form) || q('[data-product-price],[data-price],[data-product-price-cents]');
    if (d) {
      const val = d.getAttribute('data-product-price') || d.getAttribute('data-price') || d.getAttribute('data-product-price-cents');
      if (val && /^\d+$/.test(val)) return parseInt(val,10);
    }
    // 2) texte du prix (fallback)
    const moneyEl = q('.product__price .money, .product__price, .price .money, .price', form) || q('.product__price .money, .product__price, .price .money, .price');
    if (!moneyEl) return null;
    const txt = (moneyEl.textContent || '').trim();
    const digits = txt.replace(/[^\d,\.]/g, '');
    if (!digits) return null;
    // on prend le dernier séparateur comme décimal
    const m = digits.match(/^(.*?)([.,])(\d{1,2})$/);
    if (m) {
      const intPart = (m[1] || '').replace(/[^\d]/g, '');
      const dec = (m[3] || '00').padEnd(2,'0').slice(0,2);
      return (parseInt(intPart||'0',10) * 100) + parseInt(dec,10);
    }
    // pas de décimales visibles ⇒ on assume entiers
    const intOnly = digits.replace(/[^\d]/g,'');
    if (!intOnly) return null;
    return parseInt(intOnly,10) * 100;
  }

  function formatMoney(cents) {
    const fmt = document.body?.dataset?.moneyFormat || '{{amount}}';
    if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents, fmt);
    // fallback simple (EUR)
    return (cents/100).toFixed(2) + ' €';
  }

  function updatePdpState(form) {
    const left  = getLeftField(form) || getLeftField();
    const right = getRightField(form) || getRightField();
    if (!left || !right) return;
    const qty   = getQtyInput(form);

    const want = computeQty(left.value, right.value);
    if (qty) {
      qty.value = want;
      qty.setAttribute('value', want);
      qty.dispatchEvent(new Event('input',  { bubbles: true }));
      qty.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      const hiddenQty = document.createElement('input');
      hiddenQty.type = 'hidden';
      hiddenQty.name = 'quantity';
      hiddenQty.value = want;
      form.appendChild(hiddenQty);
    }

    const hint = ensureHintAfterWrapper(form);
    const stateEl = hint.querySelector('.ogod-state');
    if (stateEl) {
      if (!normalize(left.value) || !normalize(right.value)) {
        stateEl.textContent = '';
      } else if (normalize(left.value) === normalize(right.value)) {
        stateEl.textContent = 'État actuel : corrections identiques → quantité 1';
      } else {
        stateEl.textContent = 'État actuel : corrections différentes → quantité 2';
      }
    }

    // Total estimé = prix unitaire x quantité
    const perUnit = readUnitPriceCents(form);
    const totalEl = hint.querySelector('.ogod-total');
    if (perUnit && totalEl) {
      const total = perUnit * want;
      totalEl.textContent = 'Total estimé : ' + formatMoney(total);
    }
  }

  function wirePdpForm(form) {
    if (form.dataset.ogodQtyInit === 'true') return;
    form.dataset.ogodQtyInit = 'true';
    updatePdpState(form);

    document.addEventListener('change', function(ev){
      const t = ev.target;
      if (!t) return;
      if (
        t.matches('[name="properties[oeil_gauche]"], [name="oeil_gauche"], .product-option-custom.mood-eye-left select, .product-option-custom.mood-eye-left input') ||
        t.matches('[name="properties[oeil_droit]"],  [name="oeil_droit"],  .product-option-custom.mood-eye-right select, .product-option-custom.mood-eye-right input') ||
        t.matches('input[name="quantity"]')
      ) {
        updatePdpState(form);
      }
    });

    form.addEventListener('submit', function(){ updatePdpState(form); }, true);
  }

  function initPdp() {
    qa('form[action*="/cart/add"]').forEach(wirePdpForm);
  }

  /* ====== Panier/Drawer : anti < 2 en dur ====== */

  async function fetchCart() {
    const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    if (!res.ok) throw new Error('cart fetch failed');
    return res.json();
  }
  async function changeLineQtyByKey(key, quantity) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
  }
  function needsMin2(item) {
    const og = normalize(item.properties && item.properties.oeil_gauche);
    const od = normalize(item.properties && item.properties.oeil_droit);
    return og && od && og !== od;
  }

  // 1) Désactiver visuellement les boutons "−" sur les lignes concernées
  async function markCartRows() {
    try {
      const cart = await fetchCart();
      (cart.items||[]).forEach(item => {
        if (!needsMin2(item)) return;
        // marque les lignes par leur "key" si présent dans DOM
        const sel = `[data-cart-item-key="${CSS.escape(item.key)}"], [data-line-item-key="${CSS.escape(item.key)}"], [data-item-key="${CSS.escape(item.key)}"], [data-key="${CSS.escape(item.key)}"]`;
        const rows = qa(sel);
        rows.forEach(row => {
          row.setAttribute('data-min-qty', '2');
          const minus = row.querySelector('button[name="minus"], button[data-action="decrease-quantity"], .ajaxcart__qty-adjust--minus, [data-quantity-change="-1"], .quantity__button--minus, .js-qty__adjust--minus');
          if (minus) minus.disabled = true;
          const qtyInput = row.querySelector('input[name^="updates"], input.qty, input[name="quantity"], .ajaxcart__qty-num, .quantity__input, .js-qty__num');
          if (qtyInput) qtyInput.min = 2;
        });
      });
    } catch(e){}
  }

  // 2) Bloquer toute tentative côté réseau (ANTI-BYPASS)
  (function hardenFetch() {
    if (!window.fetch) return;
    const orig = window.fetch.bind(window);
    window.fetch = async function(input, init) {
      try {
        const url = typeof input === 'string' ? input : (input && input.url);
        const isChange = url && /\/cart\/(change|update)\.js/.test(url);
        if (isChange && init && init.body) {
          let bodyObj = null;
          try { bodyObj = typeof init.body === 'string' ? JSON.parse(init.body) : init.body; } catch(e){}
          if (bodyObj && typeof bodyObj === 'object') {
            const cart = await fetchCart();
            let targetItem = null;
            if (bodyObj.id) {
              targetItem = (cart.items||[]).find(i => i.key === bodyObj.id || i.id === bodyObj.id || i.variant_id === bodyObj.id);
            } else if (bodyObj.updates) {
              // cas /cart/update.js avec "updates": {key: qty}
              const key = Object.keys(bodyObj.updates)[0];
              targetItem = (cart.items||[]).find(i => i.key === key);
              if (targetItem && needsMin2(targetItem) && bodyObj.updates[key] < 2) {
                bodyObj.updates[key] = 2;
                init.body = JSON.stringify(bodyObj);
              }
            }
            if (targetItem && needsMin2(targetItem) && typeof bodyObj.quantity !== 'undefined' && bodyObj.quantity < 2) {
              bodyObj.quantity = 2;
              init.body = JSON.stringify(bodyObj);
            }
          }
        }
      } catch(e) {}
      const res = await orig(input, init);
      // après chaque modif panier, re-marque les lignes
      try {
        if (typeof input === 'string' && /\/cart\/(change|add|update)\.js/.test(input)) {
          setTimeout(markCartRows, 50);
        }
      } catch(e){}
      return res;
    };
  })();

  // 3) Délégation de clic "−" (au cas où) : bloque si data-min-qty
  document.addEventListener('click', function(ev){
    const target = ev.target.closest('button[name="minus"], button[data-action="decrease-quantity"], .ajaxcart__qty-adjust--minus, [data-quantity-change="-1"], .quantity__button--minus, .js-qty__adjust--minus');
    if (!target) return;
    const row = target.closest('[data-cart-item-key], [data-line-item-key], [data-item-key], [data-key], .cart__row, .cart-item, li.cart__item, .ajaxcart__product');
    if (row && row.getAttribute('data-min-qty') === '2') {
      const qtyInput = row.querySelector('input[name^="updates"], input.qty, input[name="quantity"], .ajaxcart__qty-num, .quantity__input, .js-qty__num');
      const current = qtyInput ? parseInt(qtyInput.value,10) : 2;
      if (current <= 2) {
        ev.preventDefault(); ev.stopPropagation(); return false;
      }
    }
  }, true);

  function initCartGuards() {
    markCartRows();
    document.addEventListener('cart:refresh', markCartRows);
    document.addEventListener('ajaxCart.afterCartLoad', markCartRows);
    document.addEventListener('shopify:section:load', markCartRows);
    const mo = new MutationObserver(() => markCartRows());
    mo.observe(document.documentElement, { childList: true, subtree: true });
    window.addEventListener('load', () => setTimeout(markCartRows, 200));
  }

  /* ====== boot ====== */
  document.addEventListener('DOMContentLoaded', function(){
    qa('form[action*="/cart/add"]').forEach(wirePdpForm);
    initCartGuards();
  });
})();
